import Vue from 'vue';
import Router from 'vue-router';
Vue.use(Router)

export default new Router({
    routes: [{
            path: '/Login',
            component: resolve => require(['@/page/Login.vue'], resolve),
        }, {
            path: '/',
            component: resolve => require(['@/page/index.vue'], resolve),
        },
        {
            path: '/index',
            component: resolve => require(['@/page/index.vue'], resolve),
            redirect: '/mini_app/manage_banner',
            children: [
                // 房屋管理
                // 房屋管理 - 房屋管理
                {
                    path: '/house_apply/house_manage',
                    component: resolve => require(['@/page/house_apply/house_manage.vue'], resolve)
                },
                // 房屋管理 - 房屋信息
                {
                    path: '/house_apply/house_info',
                    component: resolve => require(['@/page/house_apply/house_info.vue'], resolve)
                },
                // 房屋管理 - 导入房屋
                {
                    path: '/house_apply/import_house',
                    component: resolve => require(['@/page/house_apply/import_house.vue'], resolve)
                },
                // 房屋管理 - 房屋申请绑定
                {
                    path: '/house_apply/apply_house',
                    component: resolve => require(['@/page/house_apply/apply_house.vue'], resolve)
                },
                //业主管理
                {
                    path: '/owner/owner_news',
                    component: resolve => require(['@/page/owner/owner_news.vue'], resolve)
                }, // 业主信息-业主管理
                {
                    path: '/owner/look_owner_detail',
                    component: resolve => require(['@/page/owner/look_owner_detail.vue'], resolve)
                }, // 查看详情-业主信息-业主管理
                {
                    path: '/owner/give_coupon',
                    component: resolve => require(['@/page/owner/give_coupon.vue'], resolve)
                }, // 赠送优惠券-查看详情-业主信息-业主管理
                {
                    path: '/owner/integral_manage',
                    component: resolve => require(['@/page/owner/integral_manage.vue'], resolve)
                }, // 积分管理-业主管理
                {
                    path: '/owner/add_integral',
                    component: resolve => require(['@/page/owner/add_integral.vue'], resolve)
                }, // 增加积分-积分管理-业主管理
                {
                    path: '/owner/coupon_manage',
                    component: resolve => require(['@/page/owner/coupon_manage.vue'], resolve)
                }, // 优惠券管理-业主管理
                {
                    path: '/owner/add_coupon',
                    component: resolve => require(['@/page/owner/add_coupon.vue'], resolve)
                }, // 添加优惠券-优惠券管理-业主管理
                {
                    path: '/owner/coupon_way',
                    component: resolve => require(['@/page/owner/coupon_way.vue'], resolve)
                }, // 优惠券方案-业主管理
                {
                    path: '/owner/add_way',
                    component: resolve => require(['@/page/owner/add_way.vue'], resolve)
                }, // 添加优惠券领取方案-优惠券方案-业主管理
                //订单管理
                {
                    path: '/order/book_club',
                    component: resolve => require(['@/page/order/book_club.vue'], resolve)
                }, // 预约会所-订单管理
                {
                    path: '/order/book_detail',
                    component: resolve => require(['@/page/order/book_detail.vue'], resolve)
                }, // 查看详情-预约会所-订单管理
                {
                    path: '/order/service_order',
                    component: resolve => require(['@/page/order/service_order.vue'], resolve)
                }, // 服务订单-订单管理
                {
                    path: '/order/service_detail',
                    component: resolve => require(['@/page/order/service_detail.vue'], resolve)
                }, // 查看详情-服务订单-订单管理
                //服务管理
                {
                    path: '/service/home_banner',
                    component: resolve => require(['@/page/service/home_banner.vue'], resolve)
                }, // 广告推荐管理 - 服务管理
                {
                    path: '/service/add_banner',
                    component: resolve => require(['@/page/service/add_banner.vue'], resolve)
                }, // -添加轮播图-广告推荐管理-服务管理
                {
                    path: '/service/club_service',
                    component: resolve => require(['@/page/service/club_service.vue'], resolve)
                }, // 会所服务-服务管理
                {
                    path: '/service/add_service',
                    component: resolve => require(['@/page/service/add_service.vue'], resolve)
                }, // 添加会所服务-会所服务-服务管理
                {
                    path: '/service/set_time',
                    component: resolve => require(['@/page/service/set_time.vue'], resolve)
                }, // 设置服务预约时间-会所服务-服务管理
                {
                    path: '/service/add_time',
                    component: resolve => require(['@/page/service/add_time.vue'], resolve)
                }, // 添加服务预约时间段-设置服务预约时间-会所服务-服务管理
                {
                    path: '/service/vip_only',
                    component: resolve => require(['@/page/service/vip_only.vue'], resolve)
                }, // 会员专享-服务管理
                {
                    path: '/service/add_only_service',
                    component: resolve => require(['@/page/service/add_only_service.vue'], resolve)
                }, // 添加服务-会员专享-服务管理
                {
                    path: '/service/service_item',
                    component: resolve => require(['@/page/service/service_item.vue'], resolve)
                }, // 服务项目-会员专享-服务管理
                {
                    path: '/service/add_items',
                    component: resolve => require(['@/page/service/add_items.vue'], resolve)
                }, // 添加服务项目-服务项目-会员专享-服务管理

                {
                    path: '/service/vip_set_time',
                    component: resolve => require(['@/page/service/vip_set_time.vue'], resolve)
                }, // 设置-会员专享-服务项目-预约时间列表

                {
                    path: '/service/add_vip_service_time',
                    component: resolve => require(['@/page/service/add_vip_service_time.vue'], resolve)
                }, // 设置-会员专享-服务项目-添加预约时间

                //交房专用
                {
                    path: '/house/checkout_status',
                    component: resolve => require(['@/page/house/checkout_status.vue'], resolve)
                }, // 验房说明-交房专用
                {
                    path: '/house/house_ensure',
                    component: resolve => require(['@/page/house/house_ensure.vue'], resolve)
                }, // 房屋质量保证书-交房专用
                {
                    path: '/house/use_guide',
                    component: resolve => require(['@/page/house/use_guide.vue'], resolve)
                }, // 房屋使用说明书-交房专用
                //系统
                {
                    path: '/set_up/role_list',
                    component: resolve => require(['@/page/set_up/role_list.vue'], resolve)
                }, // 系统角色 - 系统
                {
                    path: '/set_up/add_role',
                    component: resolve => require(['@/page/set_up/add_role.vue'], resolve)
                }, // 添加角色-系统角色 - 系统
                {
                    path: '/set_up/menu_list',
                    component: resolve => require(['@/page/set_up/menu_list.vue'], resolve)
                }, // 系统菜单 - 系统
                {
                    path: '/set_up/add_menu',
                    component: resolve => require(['@/page/set_up/add_menu.vue'], resolve)
                }, // 添加菜单-系统菜单 - 系统
                {
                    path: '/set_up/user_list',
                    component: resolve => require(['@/page/set_up/user_list.vue'], resolve)
                }, // 添加菜单-系统菜单 - 系统
                {
                    path: '/set_up/addStaff',
                    component: resolve => require(['@/page/set_up/addStaff.vue'], resolve)
                }, // 添加菜单-系统菜单 - 系统
                
            ]
        },
    ],
    scrollBehavior(to, from, savedPosition) {
        return {
            x: 0,
            y: 0
        }
    }
})


// WEBPACK FOOTER //
// ./src/router/index.js